import React from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {BanTypeEnum} from '../../Constants/banTypeEnum';
import {formatAmount} from '../../utils/banTypeClassifier';
import BitPendingLabel from '../BitPendingLabel';
import WarningMessage from '../WarningMessage';
import BanPaymentMethodRow from './BanPaymentMethodRow';

const DebtBanStatus = ({banData, onActionClick}) => {
  const getMessage = () => {
    if (banData.isEnergy) {
      return `בשל גובה החוב לא ניתן להתקדם.
    <br />
    לתשלום יש לחייג ${window.Config.energyCallCenter}`;
    } else {
      return `בשל גובה החוב לא ניתן להתקדם. <br />לתשלום יש לחייג ${window.Config.financeCallNumber1}`;
    }
  };
  return (
    <div className={`debt-ban-status`}>
      <BanPaymentMethodRow banData={banData} />
      <div className='ban-status-card__section-divider' />
      <div className='debt-ban-status__content'>
        <div className='debt-ban-status__info'>
          {banData.payPendingStatus && <BitPendingLabel />}
          <div className='debt-ban-status__debt-label'> יתרת חוב לתשלום:</div>
          <div className='debt-ban-status__debt-amount'>₪{formatAmount(banData.amount)}</div>
        </div>

        {banData.banType === BanTypeEnum.BAN_WITH_DEBT && (
          <div className='debt-ban-status__btn'>
            <BtnSubmit text={banData.payPendingStatus ? 'להשלמת התשלום' : 'לפרטים ותשלום'} onclick={onActionClick} />
          </div>
        )}
      </div>
      {banData.banType === BanTypeEnum.BAN_WITH_DEBT_ABOVE_MAX && <WarningMessage message={getMessage()} />}
    </div>
  );
};

export default DebtBanStatus;
